import getWrappedUseMutation from "api/helpers/getWrappedUseMutation";

import apiClient from "../../../api-client";
export const useTimeTypeLabelMutation = getWrappedUseMutation(apiClient.ItineraryBookletsForumTimeTypeLabel.put);
